import Phaser from 'phaser';
import { gameConfig } from '@/config';
import { installOrientationGuard } from '@/ui/OrientationGuard';

// Entry point: instancia o Phaser.Game com a config global. As cenas registradas
// em config.ts cuidam do resto do ciclo de vida.
//
// Antes do Phaser inicializar, instalamos o guard de orientação — overlay
// DOM que pede pra virar o celular em portrait. Não toca no canvas; só
// fica por cima dele em viewports inadequados.
installOrientationGuard();
new Phaser.Game(gameConfig);
